import { Button } from "react-bootstrap";
import React from "react";

import "./ProductInvariationDialog.scss";

const Actions = {
	SHOW: "productInvariationDialog:show",
	INVARIATION_CHANGE: "productInvariationDialog:variation:change",
	ACCEPT_INVARIATION_CHANGE: "productInvariationDialog:variation:accept:change",
}
ProductInvariationDialog.Actions = Actions;

/**
 * @param {Boolean} allowChange
 * @param {Boolean} allowContinue
 * @param {String} warningMessage
 * @param {ActionBus} actionBus
 */
export default function ProductInvariationDialog ({ allowChange, allowContinue, warningMessage, actionBus }) {
	const variationUnavailRef = React.useRef(undefined);
	const variationToAcceptRef = React.useRef(undefined);
	
	actionBus?.on(Actions.SHOW, variation => {
		variationToAcceptRef.current = variation;
		variationUnavailRef.current?.showModal();
	});
	
	const dialog_keyDown = e => {
		if (e.key.toLowerCase() === "escape") {
			// prevent PDP from closing also
			e.stopPropagation();
		}
	}
	
	const acceptChangeVariation = () => {
		actionBus?.send(Actions.ACCEPT_INVARIATION_CHANGE, variationToAcceptRef.current);
		variationUnavailRef.current.close();
	}
	
	return (
		<dialog data-dialog-type="Invariation" ref={variationUnavailRef} onKeyDown={dialog_keyDown}>
			<section className="header">Change Variation</section>
			
			<section className="content"
			         dangerouslySetInnerHTML={{ __html: warningMessage }}></section>
			<section className="content">
				Not all your current options can transfer to this variation. Some options will change without
				further warning.
			</section>
			
			<footer>
				<Button onClick={() => variationUnavailRef.current.close()}>Close</Button>
				{allowContinue && (
					<Button onClick={acceptChangeVariation}>Accept</Button>
				)}
			</footer>
		</dialog>
	);
}